import { apiSlice } from "../api/apiSlice";

export const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProject: builder.query({
      query: (id) => {
        // const { id, convertedTeamName } = data || {};
        // let queryString = "";
        let queryString = `/projects/${id}`;
        // else queryString = `/projects?projectName=${convertedTeamName}`;
        return {
          url: queryString,
          method: "GET",
        };
      },
    }),
    getAllProjects: builder.query({
      query: () => {
        return {
          url: `/projects/`,
          method: "GET",
        };
      },
      providesTags: ["Projects"],
    }),
    createProject: builder.mutation({
      query: (body) => {
        return {
          url: `/projects/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Projects"],
    }),
    editProject: builder.mutation({
      query: ({ body, id }) => ({
        url: `/projects/${id}`,
        method: "PATCH",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const pathResult1 = dispatch(
          apiSlice.util.updateQueryData(
            "getAllProjects",
            undefined,
            (draft) => {
              const draftProject = draft.find((p) => p.id == arg.id);
              draftProject.projectState = arg.body.projectState;
            }
          )
        );
        try {
          await queryFulfilled;
        } catch (err) {
          pathResult1.undo();
        }
      },
    }),
    deleteProject: builder.mutation({
      query: (id) => {
        return {
          url: `/projects/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Projects"],
    }),
  }),
});

export const {
  useGetProjectQuery,
  useGetAllProjectsQuery,
  useCreateProjectMutation,
  useEditProjectMutation,
  useDeleteProjectMutation,
} = projectsApi;
